/**
 * datetime-local 與 API ISO 時間轉換（使用瀏覽器本地時區）
 *
 * 錯誤做法：new Date(iso).toISOString().slice(0, 16)
 * 會把 UTC 字串填入 datetime-local，導致顯示時間偏移（台灣 UTC+8 會差 8 小時）
 */

export function toDatetimeLocal(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function fromDatetimeLocal(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString();
}
